import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import {GridContainerAtom, GridItemAtom} from '../../to_layout/grid/grid.atom'
import TypographyAtom from '../typography/typography.atom'
import themeInfoArray from '../../../@themes/swatches/theme_info_array'
import {swatchLabelStyles} from './color_swatches.styles'

const SwatchLabel = styled(TypographyAtom)`
  ${swatchLabelStyles}
`
export interface ApThemeSwatchInfoProps {
  code: string
  id: string
  title: string
  txtColor: string
}

const apAtomName = {ap_atom_name: 'colorSwatch'}

const ColorSwatchesAtom = function () {
  const dataArr: Array<ApThemeSwatchInfoProps> = themeInfoArray
  return (
    <GridContainerAtom>
      {dataArr.map((each: ApThemeSwatchInfoProps) => {
        const {title, id, code, txtColor} = each
        return (
          <GridItemAtom key={id}>
            <Box
              {...apAtomName}
              sx={{
                backgroundColor: `${code}`,
                width: '180px',
                height: '70px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px',
                border: '1px solid rgba(0,0,0,0.1)',
                borderRadius: '6px',
              }}
            >
              <SwatchLabel ap_type="label2" ap_color={txtColor} id={id}>
                <span>{title}</span> <span>{code}</span>
              </SwatchLabel>
            </Box>
          </GridItemAtom>
        )
      })}
    </GridContainerAtom>
  )
}

export default ColorSwatchesAtom
